import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { ApiService } from './api.service';

@Injectable()
export class CaptureImportedService extends ApiService {
  constructor(private http: Http) {
    super('api/imported-captures/', http);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/capture-imported.service.ts